const level = [
  [  0,   0,  99,  99,  99,  99,   0,   0,   0,   0],
  [  0,   0,  99,   0,  52,  99,  99,  99,   0,   0],
  [  0,   0,  99,   8,  10,   0,   0,  99,   0,   0],
  [ 99,  99,  99,   0,   9,  77,   0,  99,   0,   0],
  [ 99,  51,  38,  64,   0,  99,  99,  99,   0,   0],
  [ 99,  99,  99,   7,   0,  99,   0,   0,   0,   0],
  [  0,   0,  99,   0,   0,  99,   0,   0,   0,   0],
  [  0,   0,  99,  99,  99,  99,   0,   0,   0,   0],

]

export default level